import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-date-picker",
  templateUrl: "./date-picker.component.html",
  styleUrls: ["./date-picker.component.scss"],
  standalone: false,
})
export class DatePickerComponent {
  @Input() placeholder: any;
  @Input() label: any;
  @Input() class = "";
  @Input() isFormSubmitted: boolean = false;
  @Input() readOnly: boolean = false;
  @Input()
  set control(control: FormControl) {
    this._control = control;
    this.onControlChange$.next();
  }
  get control(): FormControl {
    return this._control;
  }
  private _control: FormControl = new FormControl();

  private onControlChange$: Subject<void> = new Subject();
  @Output()
  valueChanges = new EventEmitter<any>();
  constructor() {
    this.onControlChange$.subscribe(() => {
      this.control.valueChanges
        .pipe(takeUntil(this.onControlChange$))
        .subscribe(() => this.valueChanges.emit(this.control.value));
    });
    this.onControlChange$.next();
  }

  ngOnInit(): void {}
  ngOnChanges(changes: SimpleChanges) {
    if (changes["isFormSubmitted"]) {
      this.isFormSubmitted = changes["isFormSubmitted"].currentValue;
    }
  }
}
